import { useEffect } from 'react'
import { useCurrentUserStore } from '@store'
import { purchaseManager } from '../utils/purchases/purchaseManager'

/**
 * Keeps the purchase SDK's app user id in sync with the signed-in account.
 *
 * On web this attributes any purchase to `accounts.id`, so the RevenueCat
 * webhook (whose `app_user_id` equals our account id) grants the entitlement to
 * the right account. It runs on every login path and on app boot (the current
 * user id is persisted), so a returning user is re-identified automatically.
 *
 * No-op on native — the native purchase manager is a stub (Phase 3b) — and when
 * no user is signed in. Sign-out detachment is handled by `AuthProvider`.
 */
export const usePurchaseIdentity = (): void => {
  const userID = useCurrentUserStore((state) => state.userID)

  useEffect(() => {
    if (!userID) {
      return
    }
    void purchaseManager
      .configure(userID)
      .then(() => purchaseManager.identify(userID))
      .catch(() => undefined)
  }, [userID])
}
